import React, { useState, useEffect } from "react";
import CommonTable from "./CommonTable";


const Accounts = ({tableAccountsData, TableHeadersAccounts}) => {


  return (
    <div>
      <CommonTable headers={TableHeadersAccounts} data={tableAccountsData} />
    </div>
  );
};

export default Accounts;
